// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login 2-step flow (reference UI) — scoped under .form_block_login */

/* Full-viewport vertical center below global header (UserHeader + optional banner) */
body.loginbg .login-page-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  min-height: calc(100dvh - 60px);
  padding: 90px 16px 40px;
  box-sizing: border-box;
}

body.loginbg .login-page-center .login_section {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

/* Forgot password: unify phone field (flag + code + number) like signup */
.forgot_password .form_block_login .auth-phone-field {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 53px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(245, 246, 247, 0.25);
  border-radius: 12px;
  padding: 0 10px;
  box-sizing: border-box;
}

body.light_theme .forgot_password .form_block_login .auth-phone-field {
  background: #f5f6f7;
  border: none;
}

.forgot_password .form_block_login .auth-phone-field__country {
  flex: 0 0 auto;
  min-width: 92px;
}

.forgot_password .form_block_login .auth-phone-field__divider {
  width: 1px;
  height: 30px;
  background: rgb(148 163 184 / 21%);
  margin: 11px 10px;
  flex-shrink: 0;
  margin-left: 0px;
}

.forgot_password .form_block_login .auth-phone-field__number {
  flex: 1 1 auto;
  min-width: 0;
}

.forgot_password .form_block_login .auth-phone-field__input {
  height: auto;
  min-height: 53px;
  border: none;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  padding-left: 0;
  padding-right: 14px;
  color: #1a1d21;
}

.forgot_password .form_block_login .auth-phone-field__input.input_filed:focus {
  outline: none;
}

.forgot_password .form_block_login .auth-phone-country-inner {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.forgot_password .form_block_login .auth-phone-country-flag {
  font-size: 1.1rem;
  line-height: 1;
}

.forgot_password .form_block_login .auth-phone-country-code {
  font-weight: 500;
  font-size: 14px;
  letter-spacing: -0.01em;
}

.forgot_password .form_block_login .auth-phone-country__dropdown-indicator i {
  font-size: 18px;
  color: #9ca3af;
}

.col-sm-12.input_block.qrcode_scan_block {
  text-align: center;
}

.col-sm-12.input_block.qrcode_scan_block label {
  text-align: center;
}

/* Login step 2: authenticator has no email/SMS resend — align Paste like signup row */
.form_block_login.login-wizard-root .signup-wizard-otp-actions.login-otp-actions-paste-only {
  justify-content: flex-end;
}

@media (max-height: 560px) {
  body.loginbg .login-page-center {
    min-height: auto;
    justify-content: flex-start;
  }
}

.form_block_login.login-wizard-root .login-wizard-title {
  font-size: 40px;
  font-weight: 600;
  margin: 0 0 20px;
  text-align: left;
  letter-spacing: -0.02em;
}

.form_block_login.login-wizard-root .login-wizard-tabs {
  display: flex;
  gap: 15px;
  margin: 0 0 20px;
  padding: 0;
  list-style: none;
}

.form_block_login.login-wizard-root .login-wizard-tabs button {
  flex: 1 1;
  padding: 8px 0px 5px;
  background: none;
  border: none;
  font-weight: 500;
  cursor: pointer;
  font-size: 0.9rem;
  color: inherit;
  opacity: 0.55;
  position: relative;
  text-align: center;
}

.form_block_login.login-wizard-root .login-wizard-tabs button.is-active {
  opacity: 1;
  font-weight: 500;
}

.form_block_login.login-wizard-root .login-wizard-tabs button.is-active::after {
  content: "";
  position: absolute;
  left: 36%;
  right: 36%;
  bottom: 0;
  height: 2px;
  background: #b4b4b4;
  border-radius: 2px;
}

body.light_theme .form_block_login.login-wizard-root .login-wizard-tabs button.is-active::after {
  background: #373737;
}

.form_block_login.login-wizard-root .login-wizard-bind-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-weight: 500;
  margin: 0px 0 12px;
  font-size: 14px;
}


.login-wizard-bind-row.forgot_password_link a {
  text-decoration: underline;
}

.login_section .qrcode_scan_block sub {
  bottom: 0px;
  font-size: 13px;
  margin-bottom: 8px;
}

.login_section .form_block_login .qrcode_scan_block p span {
  color: #fff;
  font-weight: 600;
}

body.light_theme .login_section .form_block_login .qrcode_scan_block p span {
  color: #000000;
}

.form_block_login.login-wizard-root .login-wizard-bind-row label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
  font-weight: 500;
}

.form_block_login.login-wizard-root .login-wizard-bind-row input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #d1aa67;
}

.form_block_login.login-wizard-root .login-wizard-bind-row a {
  color: #dbdbdb;
}

body.light_theme .form_block_login.login-wizard-root .login-wizard-bind-row a {
  color: #1a1d21;
}

.form_block_login.login-wizard-root .login-wizard-captcha {
  margin: 4px 0 8px;
  overflow: hidden;
}

.form_block_login.login-wizard-root .login-wizard-next-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 16px 20px;
  border-radius: 999px;
  border: none;
  background: #1a1d21;
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  margin-top: 4px;
  box-sizing: border-box;
}

.form_block_login.login-wizard-root .login-wizard-next-btn__spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  border-radius: 50%;
  flex-shrink: 0;
  animation: login-wizard-next-spin 0.65s linear infinite;
}

@keyframes login-wizard-next-spin {
  to {
    transform: rotate(360deg);
  }
}

body.light_theme .form_block_login.login-wizard-root .login-wizard-next-btn {
  background: #1a1d21;
  color: #fff;
}

.form_block_login.login-wizard-root .login-wizard-next-btn:hover:not(:disabled) {
  opacity: 0.92;
}

.form_block_login.login-wizard-root .login-wizard-next-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.form_block_login.login-wizard-root .login-wizard-passkey-outline {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  gap: 10px;
  width: 100%;
  margin-bottom: 24px;
  padding: 14px 16px;
  margin-top: 4px;
  border-radius: 12px;
  border: 1px solid #f2f3f463;
  background: rgb(0 0 0 / 4%);
  color: #a9a9a9;
  font-size: 14px;
  cursor: pointer;
}

body.light_theme .form_block_login.login-wizard-root .login-wizard-passkey-outline {
  border: 1px solid #F2F3F4;
  background: rgba(255, 255, 255, 0.04);
  color: #1d1d1d;
}

.form_block_login.login-wizard-root .login-wizard-passkey-outline:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.form_block_login.login-wizard-root .login-wizard-create-link {
  display: block;
  text-align: center;
  margin-top: 0px;
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
  color: #dddddd;
  opacity: 1;
}

body.light_theme .form_block_login.login-wizard-root .login-wizard-create-link {
  color: #070808;
}

button.signup-wizard-otp-link.login-otp-link {
  text-decoration: underline !important;
}

.signup-wizard-otp-stack.otp_stack_login {
  margin-top: -18px;
}

.form_block_login.login-wizard-root .lmv-panel--code .signup-wizard-otp-stack.otp_stack_login {
  margin-top: 0;
}

/* Step 2 verification heading (smaller than step 1 “Log In”) */
.form_block_login.login-wizard-root .login-wizard-title.login-wizard-title--verify {
  margin-bottom: 7px;
}

body.loginbg {
  background-color: #000000 !important;
}

body.light_theme.loginbg {
  background-color: #fff !important;
}

/* ---------- Responsive: laptop / tablet / mobile — all login tabs ---------- */

/* Laptop */
@media screen and (max-width: 1200px) {
  /* body.loginbg .login-page-center {
    padding: 20px 20px 32px;
  } */

  body.loginbg .login-page-center .login_section {
    max-width: 480px;
  }

  body.loginbg .login_form_right {
    width: 100%;
    max-width: 480px;
  }

  .form_block_login.login-wizard-root .login-wizard-title {
    font-size: 32px;
  }

  .form_block_login.login-wizard-root .login-wizard-tabs {
    gap: 12px;
  }

  .login_section .qrcode_scan img {
    max-width: 280px;
    height: auto;
  }
}

/* Tablet */
@media screen and (max-width: 991px) {
  body.loginbg .login-page-center {
    min-height: calc(100dvh - 0px);
    padding: 50px 20px 40px;
    justify-content: flex-start;
  }

  body.loginbg .login-page-center .login_section {
    max-width: 540px;
    width: 100%;
  }

  body.loginbg .login_form_right {
    width: 100%;
    max-width: 540px;
    margin: 0 auto;
  }

  body.loginbg .login_section .form_block_login.login-wizard-root {
    min-height: auto;
    width: 100%;
  }

  .form_block_login.login-wizard-root .login-wizard-title {
    font-size: 30px;
    margin-bottom: 16px;
  }

  .form_block_login.login-wizard-root .login-wizard-title.login-wizard-title--verify {
    font-size: 1.35rem;
  }

  .form_block_login.login-wizard-root .login-wizard-tabs {
    gap: 8px;
    margin-bottom: 16px;
    flex-wrap: nowrap;
    width: 100%;
  }

  .form_block_login.login-wizard-root .login-wizard-tabs button {
    font-size: 0.875rem;
    padding: 8px 4px 6px;
    min-width: 0;
  }

  .form_block_login.login-wizard-root .login-wizard-tabs button.is-active::after {
    left: 22%;
    right: 22%;
  }

  .form_block_login.login-wizard-root .login-wizard-next-btn {
    padding: 14px 18px;
    font-size: 0.95rem;
  }

  .form_block_login.login-wizard-root .login-wizard-passkey-outline {
    padding: 12px 14px;
    font-size: 0.875rem;
  }

  .form_block_login.login-wizard-root .login-wizard-bind-row {
    flex-wrap: wrap;
    gap: 10px;
    font-size: 13px;
  }

  .form_block_login.login-wizard-root .signup-wizard-otp-row {
    gap: 8px;
    justify-content: space-between;
  }

  .form_block_login.login-wizard-root .signup-wizard-otp-cell {
    max-width: 44px;
    flex: 1 1;
  }

  .col-sm-12.input_block.qrcode_scan_block {
    gap: 8px;
  }

  .login_section .qrcode_scan img {
    max-width: min(240px, 70vw);
    height: auto;
  }

  .login_section .qrcode_scan_block sub {
    font-size: 12px;
  }

  .form_block_login.login-wizard-root .qrcode_scan_block .signup-wizard-subtitle {
    font-size: 0.875rem;
    line-height: 1.45;
    padding: 0 8px;
  }

  .form_block_login.login-wizard-root .qrcode_scan_block label {
    font-size: 13px;
    white-space: normal;
    justify-content: center;
  }

  /* Verification options modal (tablet) */
  body.loginbg #VerificationOptionsModal .modal-dialog {
    max-width: min(420px, 92vw);
    margin: 1.5rem auto;
  }
}

/* Mobile / small tablets */
@media screen and (max-width: 767px) {
  .form_block_login.login-wizard-root .login-wizard-title {
    font-size: 28px;
    margin-bottom: 14px;
  }

  .form_block_login.login-wizard-root .login-wizard-title.login-wizard-title--verify {
    font-size: 1.2rem;
  }

  .form_block_login.login-wizard-root .login-wizard-tabs {
    gap: 7px;
    margin-bottom: 14px;
  }

  .form_block_login.login-wizard-root .login-wizard-tabs button {
    font-size: 14px;
    padding: 8px 5px 8px;
  }

  .form_block_login.login-wizard-root .login-wizard-next-btn {
    padding: 15px 16px;
    font-size: 16px;
  }

  body.loginbg .login-page-center .login_section,
  body.loginbg .login_form_right {
    max-width: 100%;
    width: 100%;
  }

  body.loginbg .login_section .form_block_login.login-wizard-root {
    min-height: auto;
  }

  .form_block_login .input_filed {
    height: 50px;
    border-radius: 8px;
  }

  .form_block_login .auth-phone-field {
    height: 50px;
    min-height: 50px;
    border-radius: 8px;
  }

  .form_block_login .auth-phone-field__country {
    min-width: 84px;
  }

  .form_block_login .auth-phone-field__input.input_filed {
    height: 44px;
  }

  .form_block_login label {
    font-size: 14px;
    white-space: nowrap;
  }

  .email_code .get_otp {
    top: 11px;
    padding: 0px 12px;
  }

  .email_code .get_otp .ri-eye-off-line,
  .email_code .get_otp .ri-eye-line {
    font-size: 17px;
    top: -1px;
  }

  .form_block_login .signup-wizard-otp-cell {
    max-width: 38px;
  }

  .form_block_login.login-wizard-root .signup-wizard-otp-stack.otp_stack_login {
    margin-top: -10px;
  }

  .form_block_login.login-wizard-root .lmv-panel--code .signup-wizard-otp-stack.otp_stack_login {
    margin-top: 0;
  }

  .form_block_login.login-wizard-root .signup-wizard-otp-actions {
    flex-wrap: wrap;
    gap: 8px;
  }

  .form_block_login.login-wizard-root .login-wizard-passkey-outline {
    padding: 12px 12px;
    font-size: 0.8125rem;
  }

  .form_block_login.login-wizard-root .login-wizard-create-link {
    font-size: 13px;
  }

  .form_block_login.login-wizard-root .login-wizard-bind-row {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  }

  .form_block_login.login-wizard-root .login-wizard-bind-row label {
    white-space: normal;
    font-size: 13px;
  }

  /* QR tab */
  .login_section .qrcode_scan img {
    max-width: min(220px, 72vw);
    height: auto;
  }

  .col-sm-12.input_block.qrcode_scan_block label {
    white-space: normal;
  }

  body.loginbg .login-page-center {
    min-height: calc(100dvh - 0px);
    padding: 50px 20px;
    align-items: stretch;
    justify-content: flex-start;
  }

  /* Verification method modal → bottom sheet on mobile */
  body.loginbg #VerificationOptionsModal .modal-dialog {
    max-width: 100%;
    margin: 0;
    align-items: flex-end;
    min-height: 100%;
    display: flex;
  }

  body.loginbg #VerificationOptionsModal .modal-content {
    border-radius: 16px 16px 0 0;
    width: 100%;
  }
}

/* Small phones */
@media screen and (max-width: 575px) {

  body.loginbg .login-page-center .login_section {
    max-width: 100%;
  }

  .form_block_login.login-wizard-root .login-wizard-title {
    font-size: 24px;
  }

  .form_block_login.login-wizard-root .login-wizard-next-btn {
    padding: 11px 16px;
    font-size: 15px;
  }

  .form_block_login.login-wizard-root .login-wizard-title.login-wizard-title--verify {
    font-size: 1.05rem;
  }

  /* .form_block_login.login-wizard-root .login-wizard-tabs {
    gap: 2px;
  } */

  .form_block_login.login-wizard-root .login-wizard-tabs button {
    font-size: 13px;
    padding: 8px 2px 8px;
  }

  .form_block_login.login-wizard-root .signup-wizard-subtitle {
    font-size: 0.8125rem;
    line-height: 1.45;
  }

  .form_block_login.login-wizard-root .login-wizard-tabs button.is-active::after {
    left: 12%;
    right: 12%;
  }

  .form_block_login.login-wizard-root .login-wizard-bind-row {
    gap: 10px;
    font-size: 13px;
  }

  .form_block_login.login-wizard-root .login-wizard-bind-row label {
    font-size: 12px;
    gap: 6px;
  }

  .form_block_login .signup-wizard-divider {
    margin: 10px 0px 15px;
    font-size: 13px;
  }

  .form_block_login.login-wizard-root .signup-wizard-social-row {
    gap: 10px;
  }

  .form_block_login.login-wizard-root .signup-wizard-social-btn {
    width: 44px;
    height: 44px;
  }

  /* Phone tab */
  .form_block_login .auth-phone-field__country {
    min-width: 76px;
  }

  .form_block_login .auth-phone-country-code {
    font-size: 13px;
  }

  .form_block_login .auth-phone-field__divider {
    margin: 8px 6px;
  }

  /* Email / password fields */
  .form_block_login .input_filed {
    font-size: 14px;
  }

  /* OTP verify step */
  .form_block_login.login-wizard-root .signup-wizard-otp-row {
    gap: 6px;
  }

  .form_block_login .signup-wizard-otp-cell {
    max-width: 36px;
    height: 42px;
    font-size: 16px;
  }

  .form_block_login.login-wizard-root .signup-wizard-otp-link,
  button.signup-wizard-otp-link.login-otp-link {
    font-size: 13px;
  }

  /* QR tab */
  .login_section .qrcode_scan img {
    max-width: min(200px, 78vw);
    height: auto;
  }

  .login_section .qrcode_scan_block sub {
    font-size: 11px;
  }

  .form_block_login.login-wizard-root .qrcode_scan_block label {
    font-size: 12px;
  }

  .form_block_login.login-wizard-root .login-wizard-passkey-outline {
    font-size: 0.8rem;
    padding: 11px 10px;
  }

  .form_block_login.login-wizard-root .login-wizard-create-link {
    font-size: 12px;
  }

  .form_block_login .row {
    gap: 14px;
  }
}

/* Login: phone row danger (empty / invalid number) — matches signup email error intent */
.login_section .form_block_login .input_block.login-phone-wrap--error .auth-phone-field.auth-phone-field--unified {
  border: 1px solid #dc2626 !important;
  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;
}

.login_section .form_block_login .input_block.login-phone-wrap--error .auth-phone-field.auth-phone-field--unified:focus-within {
  border-color: #dc2626 !important;
  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;
  outline: none !important;
}

/* Login /login — email+username: danger must override public/css-new/style .input_filed + :focus (same as signup) */
html body .login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,
html body .login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,
.login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,
.login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,
.login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,
.login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,
html body .login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus,
html body .login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,
html body .login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus,
html body .login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,
.login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus,
.login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,
.login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus,
.login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus-visible {
  border: 1px solid #dc2626 !important;
  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;
  outline: none !important;
}

body.light_theme html body .login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,
body.light_theme .login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,
body.light_theme .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus,
body.light_theme .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus-visible {
  border: 1px solid #dc2626 !important;
  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;
  outline: none !important;
}

/* Wrong password or generic auth error — same danger as email field */
html body .login_fullhieght .login_section .form_block_login .email_code.login-wizard-password--error .input_filed,
.login_fullhieght .login_section .form_block_login .email_code.login-wizard-password--error .input_filed,
.login_section .form_block_login .email_code.login-wizard-password--error .input_filed,
html body .login_fullhieght .login_section .form_block_login .email_code.login-wizard-password--error .input_filed:focus,
html body .login_fullhieght .login_section .form_block_login .email_code.login-wizard-password--error .input_filed:focus-visible,
.login_section .form_block_login .email_code.login-wizard-password--error .input_filed:focus,
.login_section .form_block_login .email_code.login-wizard-password--error .input_filed:focus-visible {
  border: 1px solid #dc2626 !important;
  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;
  outline: none !important;
}

body.light_theme .login_section .form_block_login .email_code.login-wizard-password--error .input_filed,
body.light_theme .login_section .form_block_login .email_code.login-wizard-password--error .input_filed:focus,
body.light_theme .login_section .form_block_login .email_code.login-wizard-password--error .input_filed:focus-visible {
  border: 1px solid #dc2626 !important;
  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;
  outline: none !important;
}


@media screen and (max-width: 440px) {


  .form_block_login.login-wizard-root .login-wizard-tabs button {
    font-size: 12px;
    padding: 7px 1px 7px;
  }

  .form_block_login.login-wizard-root .login-wizard-title {
    font-size: 22px;
  }

  .form_block_login .signup-wizard-otp-cell {
    max-width: 32px;
    height: 40px;
    font-size: 15px;
  }

  .form_block_login.login-wizard-root .signup-wizard-otp-row {
    gap: 4px;
  }

  .login_section .qrcode_scan img {
    max-width: min(180px, 82vw);
  }

  .form_block_login .auth-phone-field__country {
    min-width: 70px;
  }

  .form_block_login.login-wizard-root .login-wizard-bind-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .form_block_login.login-wizard-root .login-wizard-bind-row a {
    align-self: flex-end;
  }
}

@media screen and (max-width: 330px) {

  .form_block_login.login-wizard-root .login-wizard-tabs button {
    font-size: 11px;
  }

  .form_block_login.login-wizard-root .login-wizard-title {
    font-size: 20px;
  }

  .form_block_login .signup-wizard-otp-cell {
    max-width: 28px;
    height: 36px;
    font-size: 14px;
  }
}

/* Multi-method verification progress (ALL_REQUIRED) */
.form_block_login.login-wizard-root .login-wizard-method-progress {
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.form_block_login.login-wizard-root .login-wizard-method-progress li {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid rgba(245, 246, 247, 0.2);
  color: #9ca3af;
}

.form_block_login.login-wizard-root .login-wizard-method-progress li.is-active {
  border-color: #d1aa67;
  color: #d1aa67;
}

.form_block_login.login-wizard-root .login-wizard-method-progress li.is-done {
  border-color: rgba(34, 197, 94, 0.45);
  color: #86efac;
}

body.light_theme .form_block_login.login-wizard-root .login-wizard-method-progress li {
  border-color: #d0d5dd;
  color: #667085;
}

body.light_theme .form_block_login.login-wizard-root .login-wizard-method-progress li.is-active {
  border-color: #b8923f;
  color: #9a7a2e;
}

body.light_theme .form_block_login.login-wizard-root .login-wizard-method-progress li.is-done {
  border-color: #86efac;
  color: #167a3a;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/LoginPage/login-wizard.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAEtE,qFAAqF;AACrF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sFAAsF;AACtF;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,gFAAgF;;AAEhF,WAAW;AACX;EACE;;KAEG;;EAEH;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA,WAAW;AACX;EACE;IACE,8BAA8B;IAC9B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,SAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,wCAAwC;EACxC;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA,WAAW;EACX;IACE,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA,uDAAuD;EACvD;IACE,eAAe;IACf,SAAS;IACT,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,4BAA4B;IAC5B,WAAW;EACb;AACF;;AAEA,iBAAiB;AACjB;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;KAEG;;EAEH;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,cAAc;EACd;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,4BAA4B;EAC5B;IACE,eAAe;EACjB;;EAEA,oBAAoB;EACpB;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA,WAAW;EACX;IACE,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,yFAAyF;AACzF;EACE,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;EACxD,wBAAwB;AAC1B;;AAEA,oHAAoH;AACpH;;;;;;;;;;;;;;EAcE,oCAAoC;EACpC,wDAAwD;EACxD,wBAAwB;AAC1B;;AAEA;;;;EAIE,oCAAoC;EACpC,wDAAwD;EACxD,wBAAwB;AAC1B;;AAEA,sEAAsE;AACtE;;;;;;;EAOE,oCAAoC;EACpC,wDAAwD;EACxD,wBAAwB;AAC1B;;AAEA;;;EAGE,oCAAoC;EACpC,wDAAwD;EACxD,wBAAwB;AAC1B;;;AAGA;;;EAGE;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,sDAAsD;AACtD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":["/* Login 2-step flow (reference UI) — scoped under .form_block_login */\n\n/* Full-viewport vertical center below global header (UserHeader + optional banner) */\nbody.loginbg .login-page-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: start;\n  min-height: calc(100dvh - 60px);\n  padding: 90px 16px 40px;\n  box-sizing: border-box;\n}\n\nbody.loginbg .login-page-center .login_section {\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Forgot password: unify phone field (flag + code + number) like signup */\n.forgot_password .form_block_login .auth-phone-field {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-height: 53px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(245, 246, 247, 0.25);\n  border-radius: 12px;\n  padding: 0 10px;\n  box-sizing: border-box;\n}\n\nbody.light_theme .forgot_password .form_block_login .auth-phone-field {\n  background: #f5f6f7;\n  border: none;\n}\n\n.forgot_password .form_block_login .auth-phone-field__country {\n  flex: 0 0 auto;\n  min-width: 92px;\n}\n\n.forgot_password .form_block_login .auth-phone-field__divider {\n  width: 1px;\n  height: 30px;\n  background: rgb(148 163 184 / 21%);\n  margin: 11px 10px;\n  flex-shrink: 0;\n  margin-left: 0px;\n}\n\n.forgot_password .form_block_login .auth-phone-field__number {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.forgot_password .form_block_login .auth-phone-field__input {\n  height: auto;\n  min-height: 53px;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  padding-left: 0;\n  padding-right: 14px;\n  color: #1a1d21;\n}\n\n.forgot_password .form_block_login .auth-phone-field__input.input_filed:focus {\n  outline: none;\n}\n\n.forgot_password .form_block_login .auth-phone-country-inner {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.forgot_password .form_block_login .auth-phone-country-flag {\n  font-size: 1.1rem;\n  line-height: 1;\n}\n\n.forgot_password .form_block_login .auth-phone-country-code {\n  font-weight: 500;\n  font-size: 14px;\n  letter-spacing: -0.01em;\n}\n\n.forgot_password .form_block_login .auth-phone-country__dropdown-indicator i {\n  font-size: 18px;\n  color: #9ca3af;\n}\n\n.col-sm-12.input_block.qrcode_scan_block {\n  text-align: center;\n}\n\n.col-sm-12.input_block.qrcode_scan_block label {\n  text-align: center;\n}\n\n/* Login step 2: authenticator has no email/SMS resend — align Paste like signup row */\n.form_block_login.login-wizard-root .signup-wizard-otp-actions.login-otp-actions-paste-only {\n  justify-content: flex-end;\n}\n\n@media (max-height: 560px) {\n  body.loginbg .login-page-center {\n    min-height: auto;\n    justify-content: flex-start;\n  }\n}\n\n.form_block_login.login-wizard-root .login-wizard-title {\n  font-size: 40px;\n  font-weight: 600;\n  margin: 0 0 20px;\n  text-align: left;\n  letter-spacing: -0.02em;\n}\n\n.form_block_login.login-wizard-root .login-wizard-tabs {\n  display: flex;\n  gap: 15px;\n  margin: 0 0 20px;\n  padding: 0;\n  list-style: none;\n}\n\n.form_block_login.login-wizard-root .login-wizard-tabs button {\n  flex: 1 1;\n  padding: 8px 0px 5px;\n  background: none;\n  border: none;\n  font-weight: 500;\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: inherit;\n  opacity: 0.55;\n  position: relative;\n  text-align: center;\n}\n\n.form_block_login.login-wizard-root .login-wizard-tabs button.is-active {\n  opacity: 1;\n  font-weight: 500;\n}\n\n.form_block_login.login-wizard-root .login-wizard-tabs button.is-active::after {\n  content: \"\";\n  position: absolute;\n  left: 36%;\n  right: 36%;\n  bottom: 0;\n  height: 2px;\n  background: #b4b4b4;\n  border-radius: 2px;\n}\n\nbody.light_theme .form_block_login.login-wizard-root .login-wizard-tabs button.is-active::after {\n  background: #373737;\n}\n\n.form_block_login.login-wizard-root .login-wizard-bind-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  font-weight: 500;\n  margin: 0px 0 12px;\n  font-size: 14px;\n}\n\n\n.login-wizard-bind-row.forgot_password_link a {\n  text-decoration: underline;\n}\n\n.login_section .qrcode_scan_block sub {\n  bottom: 0px;\n  font-size: 13px;\n  margin-bottom: 8px;\n}\n\n.login_section .form_block_login .qrcode_scan_block p span {\n  color: #fff;\n  font-weight: 600;\n}\n\nbody.light_theme .login_section .form_block_login .qrcode_scan_block p span {\n  color: #000000;\n}\n\n.form_block_login.login-wizard-root .login-wizard-bind-row label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  margin: 0;\n  font-weight: 500;\n}\n\n.form_block_login.login-wizard-root .login-wizard-bind-row input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #d1aa67;\n}\n\n.form_block_login.login-wizard-root .login-wizard-bind-row a {\n  color: #dbdbdb;\n}\n\nbody.light_theme .form_block_login.login-wizard-root .login-wizard-bind-row a {\n  color: #1a1d21;\n}\n\n.form_block_login.login-wizard-root .login-wizard-captcha {\n  margin: 4px 0 8px;\n  overflow: hidden;\n}\n\n.form_block_login.login-wizard-root .login-wizard-next-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  padding: 16px 20px;\n  border-radius: 999px;\n  border: none;\n  background: #1a1d21;\n  color: #fff;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  margin-top: 4px;\n  box-sizing: border-box;\n}\n\n.form_block_login.login-wizard-root .login-wizard-next-btn__spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(255, 255, 255, 0.35);\n  border-top-color: #fff;\n  border-radius: 50%;\n  flex-shrink: 0;\n  animation: login-wizard-next-spin 0.65s linear infinite;\n}\n\n@keyframes login-wizard-next-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\nbody.light_theme .form_block_login.login-wizard-root .login-wizard-next-btn {\n  background: #1a1d21;\n  color: #fff;\n}\n\n.form_block_login.login-wizard-root .login-wizard-next-btn:hover:not(:disabled) {\n  opacity: 0.92;\n}\n\n.form_block_login.login-wizard-root .login-wizard-next-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.form_block_login.login-wizard-root .login-wizard-passkey-outline {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  gap: 10px;\n  width: 100%;\n  margin-bottom: 24px;\n  padding: 14px 16px;\n  margin-top: 4px;\n  border-radius: 12px;\n  border: 1px solid #f2f3f463;\n  background: rgb(0 0 0 / 4%);\n  color: #a9a9a9;\n  font-size: 14px;\n  cursor: pointer;\n}\n\nbody.light_theme .form_block_login.login-wizard-root .login-wizard-passkey-outline {\n  border: 1px solid #F2F3F4;\n  background: rgba(255, 255, 255, 0.04);\n  color: #1d1d1d;\n}\n\n.form_block_login.login-wizard-root .login-wizard-passkey-outline:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.form_block_login.login-wizard-root .login-wizard-create-link {\n  display: block;\n  text-align: center;\n  margin-top: 0px;\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: underline;\n  color: #dddddd;\n  opacity: 1;\n}\n\nbody.light_theme .form_block_login.login-wizard-root .login-wizard-create-link {\n  color: #070808;\n}\n\nbutton.signup-wizard-otp-link.login-otp-link {\n  text-decoration: underline !important;\n}\n\n.signup-wizard-otp-stack.otp_stack_login {\n  margin-top: -18px;\n}\n\n.form_block_login.login-wizard-root .lmv-panel--code .signup-wizard-otp-stack.otp_stack_login {\n  margin-top: 0;\n}\n\n/* Step 2 verification heading (smaller than step 1 “Log In”) */\n.form_block_login.login-wizard-root .login-wizard-title.login-wizard-title--verify {\n  margin-bottom: 7px;\n}\n\nbody.loginbg {\n  background-color: #000000 !important;\n}\n\nbody.light_theme.loginbg {\n  background-color: #fff !important;\n}\n\n/* ---------- Responsive: laptop / tablet / mobile — all login tabs ---------- */\n\n/* Laptop */\n@media screen and (max-width: 1200px) {\n  /* body.loginbg .login-page-center {\n    padding: 20px 20px 32px;\n  } */\n\n  body.loginbg .login-page-center .login_section {\n    max-width: 480px;\n  }\n\n  body.loginbg .login_form_right {\n    width: 100%;\n    max-width: 480px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-title {\n    font-size: 32px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-tabs {\n    gap: 12px;\n  }\n\n  .login_section .qrcode_scan img {\n    max-width: 280px;\n    height: auto;\n  }\n}\n\n/* Tablet */\n@media screen and (max-width: 991px) {\n  body.loginbg .login-page-center {\n    min-height: calc(100dvh - 0px);\n    padding: 50px 20px 40px;\n    justify-content: flex-start;\n  }\n\n  body.loginbg .login-page-center .login_section {\n    max-width: 540px;\n    width: 100%;\n  }\n\n  body.loginbg .login_form_right {\n    width: 100%;\n    max-width: 540px;\n    margin: 0 auto;\n  }\n\n  body.loginbg .login_section .form_block_login.login-wizard-root {\n    min-height: auto;\n    width: 100%;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-title {\n    font-size: 30px;\n    margin-bottom: 16px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-title.login-wizard-title--verify {\n    font-size: 1.35rem;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-tabs {\n    gap: 8px;\n    margin-bottom: 16px;\n    flex-wrap: nowrap;\n    width: 100%;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-tabs button {\n    font-size: 0.875rem;\n    padding: 8px 4px 6px;\n    min-width: 0;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-tabs button.is-active::after {\n    left: 22%;\n    right: 22%;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-next-btn {\n    padding: 14px 18px;\n    font-size: 0.95rem;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-passkey-outline {\n    padding: 12px 14px;\n    font-size: 0.875rem;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-bind-row {\n    flex-wrap: wrap;\n    gap: 10px;\n    font-size: 13px;\n  }\n\n  .form_block_login.login-wizard-root .signup-wizard-otp-row {\n    gap: 8px;\n    justify-content: space-between;\n  }\n\n  .form_block_login.login-wizard-root .signup-wizard-otp-cell {\n    max-width: 44px;\n    flex: 1 1 0;\n  }\n\n  .col-sm-12.input_block.qrcode_scan_block {\n    gap: 8px;\n  }\n\n  .login_section .qrcode_scan img {\n    max-width: min(240px, 70vw);\n    height: auto;\n  }\n\n  .login_section .qrcode_scan_block sub {\n    font-size: 12px;\n  }\n\n  .form_block_login.login-wizard-root .qrcode_scan_block .signup-wizard-subtitle {\n    font-size: 0.875rem;\n    line-height: 1.45;\n    padding: 0 8px;\n  }\n\n  .form_block_login.login-wizard-root .qrcode_scan_block label {\n    font-size: 13px;\n    white-space: normal;\n    justify-content: center;\n  }\n\n  /* Verification options modal (tablet) */\n  body.loginbg #VerificationOptionsModal .modal-dialog {\n    max-width: min(420px, 92vw);\n    margin: 1.5rem auto;\n  }\n}\n\n/* Mobile / small tablets */\n@media screen and (max-width: 767px) {\n  .form_block_login.login-wizard-root .login-wizard-title {\n    font-size: 28px;\n    margin-bottom: 14px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-title.login-wizard-title--verify {\n    font-size: 1.2rem;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-tabs {\n    gap: 7px;\n    margin-bottom: 14px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-tabs button {\n    font-size: 14px;\n    padding: 8px 5px 8px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-next-btn {\n    padding: 15px 16px;\n    font-size: 16px;\n  }\n\n  body.loginbg .login-page-center .login_section,\n  body.loginbg .login_form_right {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  body.loginbg .login_section .form_block_login.login-wizard-root {\n    min-height: auto;\n  }\n\n  .form_block_login .input_filed {\n    height: 50px;\n    border-radius: 8px;\n  }\n\n  .form_block_login .auth-phone-field {\n    height: 50px;\n    min-height: 50px;\n    border-radius: 8px;\n  }\n\n  .form_block_login .auth-phone-field__country {\n    min-width: 84px;\n  }\n\n  .form_block_login .auth-phone-field__input.input_filed {\n    height: 44px;\n  }\n\n  .form_block_login label {\n    font-size: 14px;\n    white-space: nowrap;\n  }\n\n  .email_code .get_otp {\n    top: 11px;\n    padding: 0px 12px;\n  }\n\n  .email_code .get_otp .ri-eye-off-line,\n  .email_code .get_otp .ri-eye-line {\n    font-size: 17px;\n    top: -1px;\n  }\n\n  .form_block_login .signup-wizard-otp-cell {\n    max-width: 38px;\n  }\n\n  .form_block_login.login-wizard-root .signup-wizard-otp-stack.otp_stack_login {\n    margin-top: -10px;\n  }\n\n  .form_block_login.login-wizard-root .lmv-panel--code .signup-wizard-otp-stack.otp_stack_login {\n    margin-top: 0;\n  }\n\n  .form_block_login.login-wizard-root .signup-wizard-otp-actions {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-passkey-outline {\n    padding: 12px 12px;\n    font-size: 0.8125rem;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-create-link {\n    font-size: 13px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-bind-row {\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-bind-row label {\n    white-space: normal;\n    font-size: 13px;\n  }\n\n  /* QR tab */\n  .login_section .qrcode_scan img {\n    max-width: min(220px, 72vw);\n    height: auto;\n  }\n\n  .col-sm-12.input_block.qrcode_scan_block label {\n    white-space: normal;\n  }\n\n  body.loginbg .login-page-center {\n    min-height: calc(100dvh - 0px);\n    padding: 50px 20px;\n    align-items: stretch;\n    justify-content: flex-start;\n  }\n\n  /* Verification method modal → bottom sheet on mobile */\n  body.loginbg #VerificationOptionsModal .modal-dialog {\n    max-width: 100%;\n    margin: 0;\n    align-items: flex-end;\n    min-height: 100%;\n    display: flex;\n  }\n\n  body.loginbg #VerificationOptionsModal .modal-content {\n    border-radius: 16px 16px 0 0;\n    width: 100%;\n  }\n}\n\n/* Small phones */\n@media screen and (max-width: 575px) {\n\n  body.loginbg .login-page-center .login_section {\n    max-width: 100%;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-title {\n    font-size: 24px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-next-btn {\n    padding: 11px 16px;\n    font-size: 15px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-title.login-wizard-title--verify {\n    font-size: 1.05rem;\n  }\n\n  /* .form_block_login.login-wizard-root .login-wizard-tabs {\n    gap: 2px;\n  } */\n\n  .form_block_login.login-wizard-root .login-wizard-tabs button {\n    font-size: 13px;\n    padding: 8px 2px 8px;\n  }\n\n  .form_block_login.login-wizard-root .signup-wizard-subtitle {\n    font-size: 0.8125rem;\n    line-height: 1.45;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-tabs button.is-active::after {\n    left: 12%;\n    right: 12%;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-bind-row {\n    gap: 10px;\n    font-size: 13px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-bind-row label {\n    font-size: 12px;\n    gap: 6px;\n  }\n\n  .form_block_login .signup-wizard-divider {\n    margin: 10px 0px 15px;\n    font-size: 13px;\n  }\n\n  .form_block_login.login-wizard-root .signup-wizard-social-row {\n    gap: 10px;\n  }\n\n  .form_block_login.login-wizard-root .signup-wizard-social-btn {\n    width: 44px;\n    height: 44px;\n  }\n\n  /* Phone tab */\n  .form_block_login .auth-phone-field__country {\n    min-width: 76px;\n  }\n\n  .form_block_login .auth-phone-country-code {\n    font-size: 13px;\n  }\n\n  .form_block_login .auth-phone-field__divider {\n    margin: 8px 6px;\n  }\n\n  /* Email / password fields */\n  .form_block_login .input_filed {\n    font-size: 14px;\n  }\n\n  /* OTP verify step */\n  .form_block_login.login-wizard-root .signup-wizard-otp-row {\n    gap: 6px;\n  }\n\n  .form_block_login .signup-wizard-otp-cell {\n    max-width: 36px;\n    height: 42px;\n    font-size: 16px;\n  }\n\n  .form_block_login.login-wizard-root .signup-wizard-otp-link,\n  button.signup-wizard-otp-link.login-otp-link {\n    font-size: 13px;\n  }\n\n  /* QR tab */\n  .login_section .qrcode_scan img {\n    max-width: min(200px, 78vw);\n    height: auto;\n  }\n\n  .login_section .qrcode_scan_block sub {\n    font-size: 11px;\n  }\n\n  .form_block_login.login-wizard-root .qrcode_scan_block label {\n    font-size: 12px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-passkey-outline {\n    font-size: 0.8rem;\n    padding: 11px 10px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-create-link {\n    font-size: 12px;\n  }\n\n  .form_block_login .row {\n    gap: 14px;\n  }\n}\n\n/* Login: phone row danger (empty / invalid number) — matches signup email error intent */\n.login_section .form_block_login .input_block.login-phone-wrap--error .auth-phone-field.auth-phone-field--unified {\n  border: 1px solid #dc2626 !important;\n  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;\n}\n\n.login_section .form_block_login .input_block.login-phone-wrap--error .auth-phone-field.auth-phone-field--unified:focus-within {\n  border-color: #dc2626 !important;\n  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;\n  outline: none !important;\n}\n\n/* Login /login — email+username: danger must override public/css-new/style .input_filed + :focus (same as signup) */\nhtml body .login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,\nhtml body .login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,\n.login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,\n.login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,\n.login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,\n.login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,\nhtml body .login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus,\nhtml body .login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,\nhtml body .login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus,\nhtml body .login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,\n.login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus,\n.login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,\n.login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus,\n.login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus-visible {\n  border: 1px solid #dc2626 !important;\n  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;\n  outline: none !important;\n}\n\nbody.light_theme html body .login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,\nbody.light_theme .login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,\nbody.light_theme .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus,\nbody.light_theme .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus-visible {\n  border: 1px solid #dc2626 !important;\n  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;\n  outline: none !important;\n}\n\n/* Wrong password or generic auth error — same danger as email field */\nhtml body .login_fullhieght .login_section .form_block_login .email_code.login-wizard-password--error .input_filed,\n.login_fullhieght .login_section .form_block_login .email_code.login-wizard-password--error .input_filed,\n.login_section .form_block_login .email_code.login-wizard-password--error .input_filed,\nhtml body .login_fullhieght .login_section .form_block_login .email_code.login-wizard-password--error .input_filed:focus,\nhtml body .login_fullhieght .login_section .form_block_login .email_code.login-wizard-password--error .input_filed:focus-visible,\n.login_section .form_block_login .email_code.login-wizard-password--error .input_filed:focus,\n.login_section .form_block_login .email_code.login-wizard-password--error .input_filed:focus-visible {\n  border: 1px solid #dc2626 !important;\n  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;\n  outline: none !important;\n}\n\nbody.light_theme .login_section .form_block_login .email_code.login-wizard-password--error .input_filed,\nbody.light_theme .login_section .form_block_login .email_code.login-wizard-password--error .input_filed:focus,\nbody.light_theme .login_section .form_block_login .email_code.login-wizard-password--error .input_filed:focus-visible {\n  border: 1px solid #dc2626 !important;\n  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;\n  outline: none !important;\n}\n\n\n@media screen and (max-width: 440px) {\n\n\n  .form_block_login.login-wizard-root .login-wizard-tabs button {\n    font-size: 12px;\n    padding: 7px 1px 7px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-title {\n    font-size: 22px;\n  }\n\n  .form_block_login .signup-wizard-otp-cell {\n    max-width: 32px;\n    height: 40px;\n    font-size: 15px;\n  }\n\n  .form_block_login.login-wizard-root .signup-wizard-otp-row {\n    gap: 4px;\n  }\n\n  .login_section .qrcode_scan img {\n    max-width: min(180px, 82vw);\n  }\n\n  .form_block_login .auth-phone-field__country {\n    min-width: 70px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-bind-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-bind-row a {\n    align-self: flex-end;\n  }\n}\n\n@media screen and (max-width: 330px) {\n\n  .form_block_login.login-wizard-root .login-wizard-tabs button {\n    font-size: 11px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-title {\n    font-size: 20px;\n  }\n\n  .form_block_login .signup-wizard-otp-cell {\n    max-width: 28px;\n    height: 36px;\n    font-size: 14px;\n  }\n}\n\n/* Multi-method verification progress (ALL_REQUIRED) */\n.form_block_login.login-wizard-root .login-wizard-method-progress {\n  list-style: none;\n  margin: 12px 0 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.form_block_login.login-wizard-root .login-wizard-method-progress li {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 999px;\n  border: 1px solid rgba(245, 246, 247, 0.2);\n  color: #9ca3af;\n}\n\n.form_block_login.login-wizard-root .login-wizard-method-progress li.is-active {\n  border-color: #d1aa67;\n  color: #d1aa67;\n}\n\n.form_block_login.login-wizard-root .login-wizard-method-progress li.is-done {\n  border-color: rgba(34, 197, 94, 0.45);\n  color: #86efac;\n}\n\nbody.light_theme .form_block_login.login-wizard-root .login-wizard-method-progress li {\n  border-color: #d0d5dd;\n  color: #667085;\n}\n\nbody.light_theme .form_block_login.login-wizard-root .login-wizard-method-progress li.is-active {\n  border-color: #b8923f;\n  color: #9a7a2e;\n}\n\nbody.light_theme .form_block_login.login-wizard-root .login-wizard-method-progress li.is-done {\n  border-color: #86efac;\n  color: #167a3a;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
